import layoutsCommponents from "./layoutsCommponents";
import Table from "./Table";
import Charts from "./Charts";
import Loader from "./Loader";
import imagePicker from "./imagePicker";
import Provider_Permissions_Detail_Dialog from "./Provider Permissions Detail Dialog";
import Dashboard from "./Dashboard";

const components={
     layoutsCommponents,
     Table,
     Charts,
     Loader,
     imagePicker,
     Provider_Permissions_Detail_Dialog,
     Dashboard
}
export default components